import React from 'react';

interface StatTileProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  onClick?: () => void;
}

const StatTile: React.FC<StatTileProps> = ({ icon, label, value, onClick }) => (
  <div
    onClick={onClick}
    className={`group flex items-center gap-3 px-2.5 py-2.5 rounded-lg ${onClick ? 'cursor-pointer hover:bg-white/[0.04] transition-colors' : ''}`}
  >
    <span className="icon-tile">{icon}</span>
    <span className="flex-1 text-[13px] text-gray-400">{label}</span>
    <span className="text-num text-[13px] font-medium text-gray-100">{value}</span>
    {onClick && <span className="text-[11px] text-gray-600 group-hover:text-accent-300 group-hover:translate-x-0.5 transition-all">→</span>}
  </div>
);

export default StatTile;
